import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faEnvelope } from "@fortawesome/pro-regular-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";

import { Icon } from "@/components";
import { BrandsIcon } from "@/components/BrandsIcon/BrandsIcon";
import { classNames } from "@/utils/classNames";

import { ActivityView, formatRelativeTime } from "./recentSignalsBox.utils";

/** One compact activity row: the lead's last outbound email / LinkedIn action (mirrors a signal row). */
export const RecentActivityRow: FunctionComponent<{ view: ActivityView; firstName: string }> = ({
	view,
	firstName,
}) => {
	const { t } = useTranslation();
	const isEmail = view.channel === "email";
	const time = formatRelativeTime(view.timeIso);
	const tileClassName = isEmail
		? "bg-blue-action-200 text-blue-action"
		: "bg-blue-action-200 text-brand-linkedin";

	return (
		<div className="flex gap-2.5 p-3" data-testid="lead-panel-recent-activity">
			<span
				className={classNames(
					"flex h-7 w-7 shrink-0 items-center justify-center rounded-md",
					tileClassName
				)}
			>
				{isEmail ? (
					<Icon className="h-3.5 w-3.5" icon={faEnvelope} />
				) : (
					<BrandsIcon className="h-3.5 w-3.5" icon={faLinkedinIn as IconDefinition} />
				)}
			</span>

			<div className="min-w-0 flex-1">
				<p className="truncate text-[13px] font-semibold text-text">
					{t(view.titleKey, { name: firstName })}
				</p>
				{view.snippet && <p className="line-clamp-1 text-xs text-text-secondary">{view.snippet}</p>}
				{time && <p className="mt-0.5 text-[10.5px] text-text-tertiary">{time}</p>}
			</div>
		</div>
	);
};
